import {toast} from 'sonner';
import {tr} from '@/i18n/copy';
import {errMsg} from '@/lib/api';

// Call only after the corresponding write has resolved successfully. Never use
// an HTTP interceptor: previews, validation and queued jobs are not completed saves.
export function confirmAction(message){
 const text=tr(message);toast.success(text,{id:'tps-action-result',description:undefined,duration:6500,closeButton:true});return text;
}
export function actionFailed(error){
 const message=errMsg(error);toast.error(message,{id:'tps-action-result',description:undefined,duration:10000,closeButton:true});return message;
}
export async function refreshAfterAction(refresh){
 try{return await refresh();}
 catch(error){toast.warning(tr('Salvataggio riuscito. Aggiornamento della schermata non disponibile: ricarica senza ripetere il salvataggio.'),{id:'tps-action-result',description:errMsg(error),duration:10000,closeButton:true});return null;}
}
